import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import Footer from "./Footer";
import { COPY } from "../lib/i18n";
import { PRIVACY_COPY } from "../lib/privacy";

function detectLang() {
  if (typeof navigator !== "undefined") {
    const l = (navigator.language || "en").toLowerCase();
    if (l.startsWith("no") || l.startsWith("nb") || l.startsWith("nn") || l.startsWith("da") || l.startsWith("sv")) {
      return "no";
    }
  }
  return "en";
}

export default function Privacy() {
  const [lang, setLang] = useState("en");

  useEffect(() => {
    const stored = typeof window !== "undefined" ? window.localStorage.getItem("np-lang") : null;
    setLang(stored || detectLang());
  }, []);

  useEffect(() => {
    if (typeof window !== "undefined") window.localStorage.setItem("np-lang", lang);
    document.documentElement.lang = lang;
    window.scrollTo(0, 0);
  }, [lang]);

  const t = COPY[lang] || COPY.en;
  const p = PRIVACY_COPY[lang] || PRIVACY_COPY.en;

  return (
    <div className="App">
      <Nav lang={lang} setLang={setLang} t={t} />
      <main className="border-b border-rule">
        <article
          data-testid="privacy-section"
          className="mx-auto max-w-3xl px-6 md:px-10 py-20 md:py-28"
        >
          <Link
            to="/"
            data-testid="privacy-back-link"
            className="font-mono text-[11px] tracking-[0.22em] uppercase text-mist hover:text-ember transition-colors"
          >
            {p.nav_back}
          </Link>

          <div className="mt-8 font-mono text-[11px] tracking-[0.22em] uppercase text-ember">
            § {p.title}
          </div>
          <h1 className="mt-4 font-serif text-5xl md:text-6xl leading-[0.98] tracking-tight">
            {p.title}.
          </h1>
          <p className="mt-3 font-mono text-[10px] tracking-[0.22em] uppercase text-mist">
            {p.updated}
          </p>

          <p className="mt-10 text-lg leading-relaxed text-ink">{p.intro}</p>

          <section className="mt-12 border-l-2 border-terracotta pl-6">
            <h2 className="font-serif text-2xl">{p.controller_title}</h2>
            <p className="mt-2 whitespace-pre-line text-mist leading-relaxed">{p.controller_body}</p>
          </section>

          <div className="mt-12 space-y-12">
            {p.sections.map((s, i) => (
              <section key={s.h} data-testid={`privacy-section-${i}`}>
                <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-mist mb-2">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h2 className="font-serif text-3xl md:text-4xl leading-tight">{s.h}</h2>
                <div className="mt-4 space-y-3 text-base md:text-lg leading-relaxed text-ink">
                  {s.p.map((para, j) => (
                    <p key={j}>{para}</p>
                  ))}
                </div>
              </section>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-rule">
            <p className="whitespace-pre-line font-serif text-2xl italic text-mist">
              {p.sign_off}
            </p>
          </div>
        </article>
      </main>
      <Footer t={t} />
    </div>
  );
}
